// bao migrate skip
import "./../bindings/bao-date-time-box";
import * as ko from "knockout";
import * as $ from "jquery";
import * as moment from "moment";
import Bao from "./../services/bao-service";
import BaoMenu from "./../services/bao-menu";
import D3Scheduler from "./../factories/d3-scheduler";
import * as d3 from "d3";

class HolidayOverviewModel {
    Bao;
    TabPage;
    Element;
    HolidayOverviewCollection = ko.observableArray([]);
    ShowOverview = ko.observable(false);
    //Filter:
    Years = ko.observableArray([]);
    Months = ko.observableArray([]);
    SelectedYear = ko.observable();
    SelectedMonth = ko.observable();
    SelectedMonthYear = ko.pureComputed(() => {
        return <any>ko.unwrap(this.SelectedYear) + ko.unwrap(this.SelectedMonth);
    }).extend({ rateLimit: { method: "notifyWhenChangesStop", timeout: 400 } });
    constructor(tabPage, element) {
        this.Bao = Bao;
        this.TabPage = tabPage;
        this.Element = element;
        tabPage.MenuEvents.push(BaoMenu.registerEvent((value) => {
            if (this.TabPage != null && this.TabPage.IsActiveTab != null && this.TabPage.IsActiveTab() === true) {
                switch (value.ActionKey()) {
                    case "HolidayOverviewRefresh":
                        this.RefreshHolidaylist();
                        break;
                    case "HolidayOverviewPreviousMonth":
                        this.SelectPreviousMonth();
                        break;
                    case "HolidayOverviewNextMonth":
                        this.SelectNextMonth();
                        break;
                }
            }
        }));
        this.SelectedMonthYear.subscribe(() => {
            this.RefreshHolidaylist();
        });
    }
    SelectPreviousMonth() {
        this.ChangeMonth(-1);
    }
    ;
    SelectNextMonth() {
        this.ChangeMonth(1);
    }
    ;
    ChangeMonth(d) {
        var m = Number(this.SelectedMonth());
        var y = Number(this.SelectedYear());
        if ((m + d) < 1) {
            this.SelectedMonth(12);
            this.SelectedYear(y + d);
        }
        else if ((m + d) > 12) {
            this.SelectedMonth(1);
            this.SelectedYear(y + d);
        }
        else {
            this.SelectedMonth(m + d);
        }
    }
    ;
    loadFilter() {
        var def = $.Deferred();
        $.when(Bao.post("SynosetMasterData/GetYearCollection", JSON.stringify({}), (result) => {
            var currentYear = new Date().getFullYear();
            for (var r in result) {
                if (result[r] != null) {
                    this.Years.push(result[r]); //Liste mit jahreszahlen erstellen
                }
            }
            this.SelectedYear(currentYear);
        })).then(() => {
            Bao.post("SynosetMasterData/GetMonthCollection", JSON.stringify({}), (result) => {
                var currentMonth = new Date().getMonth() + 1;
                for (var r in result) {
                    if (result[r] != null)
                        this.Months.push(result[r]); //Liste mit jahreszahlen erstellen
                }
                this.SelectedMonth(currentMonth);
                return def.resolve();
            });
        });
        return def.promise();
    }
    ;
    loaded() {
        var def = $.Deferred();
        this.loadFilter().then(() => {
            this.RefreshHolidaylist().then(() => { def.resolve(); });
        });
        return def.promise();
    }
    ;
    PeformRefresh() {
        //this.RefreshPerson(); == bug!
        this.RefreshHolidaylist();
    }
    ;
    RefreshHolidaylist(model?) {
        this.TabPage.IsLoading(true);
        return Bao.post("Holidaylist/GetHolidayOverviewCollection", JSON.stringify({
            year: this.SelectedYear(),
            month: this.SelectedMonth(),
        }), (result) => {
            if (result != null && result != undefined && result !== false) {
                // Diagrammdaten setzten und zeichnen:
                this.ShowOverview(true);
                this.RefreshScheduler(this.SelectedYear(), this.SelectedMonth(), result);
            }
            else {
                this.ShowOverview(false);
            }
            this.TabPage.IsLoading(false);
        });
    }
    ;
    /** @typedef {object} D3Scheduler */
    scheduler = null;
    RefreshScheduler(year, month, resources) {
        var tmpEventDateTime;
        //HolidayType://undefined = 0,Weekend = 1,SpecialHoliday = 2,HolidayApplied = 3,HolidayApproved = 4,ExtraHolidayApplied = 5,ExtraHolidayApproved = 6,Ill = 7
        var eventClasses = ["EventDefault", "EventWeekend", "EventSpecialHoliday", "EventHolidayApplied", "EventHolidayApproved", "EventExtraHolidayApplied", "ExtraHolidayApproved", "EventIll"];
        // first clear old data:
        this.scheduler.Persons = [];
        this.scheduler.Events = [];
        for (var r in resources) {
            if (resources[r] != null) {
                // add person
                this.scheduler.Persons.push({ Id: resources[r].PersonId, Name: resources[r].FullName, GroupName: null });
                if (typeof resources[r].HolidayParts !== "undefined" && resources[r].HolidayParts !== null) {
                    for (var z in resources[r].HolidayParts) {
                        if (resources[r].HolidayParts[z] !== null) {
                            tmpEventDateTime = moment(resources[r].HolidayParts[z].DateJs, Bao.Utils.DateTimeFormat).toDate();
                            // add event
                            this.scheduler.Events.push({
                                Id: resources[r].PersonId + "." + z,
                                Type: eventClasses[resources[r].HolidayParts[z].HolidayType],
                                Text: resources[r].HolidayParts[z].Remark,
                                PersonId: resources[r].PersonId,
                                DateTime: d3.time.day(tmpEventDateTime),
                                Duration: resources[r].HolidayParts[z].Duration
                            });
                        }
                    }
                }
            }
        }
        // set date-period to show: first day of month to last day of month
        this.scheduler.SetDomain(new Date(year, month - 1, 1), new Date(year, month, 0));
        // draw/redraw d3Scheduler
        this.scheduler.draw();
    }
    ;
    Eventd3SchedulerClickEvent = function (event) {
    };
    init() {
        Bao.Session.GetMessage("HolidayOverviewTabTitle")
            .done((title) => {
            this.TabPage.Title(title);
        });
        // set d3 localization:
        var locDef = ko.observable();
        locDef.subscribe((val: any) => {
            if (typeof val !== "undefined" && val !== null && val !== "") {
                var formatter = d3.locale(JSON.parse(val));
                d3.time.format = formatter.timeFormat as any;
                (d3 as any).format = formatter.numberFormat;
            }
        });
        Bao.Session.GetMessage("d3localization", locDef);
        // init d3scheduler
        this.scheduler = new D3Scheduler($(this.Element).find(".schedulerContainer")[0]);
        this.scheduler.Width = 1100;
        this.scheduler.Height = 350;
        this.scheduler.ShowPersonGroups = false;
        this.scheduler.ShowEmptyEventCells = true;
        // register custom click-event-listener:
        this.scheduler.EventOnClickFn = this.Eventd3SchedulerClickEvent;
        this.scheduler.EventShowTextOnMouseOver = true;
        this.scheduler.EventShowTextOnMouseOverAccessor = function (d) { return d.Text; };
    }
    ;
    dispose() {
        // TODO 
        //console.log(self.constructor.name, "dispose");
    }
    ;
}
export default HolidayOverviewModel;